import { Component, effect, inject, Input, ViewChild } from '@angular/core';
import { WidgetStore } from '../../../../../stores/grid/widget.state';
import {
  CustomGridStackWidget,
  TeaserItem,
} from '../../../../../services/grid-widget-config.service';
import { getState } from '@ngrx/signals';
import { BookmarkStore } from '../../../../../stores/bookmark/bookmark.state';
import { Bookmark } from '../../../../../models/bookmark';
import { Carousel, CarouselModule } from 'primeng/carousel';
import { PrimeTemplate } from 'primeng/api';
import { ButtonDirective } from 'primeng/button';
import { BookmarkButtonComponent } from '../../../../atoms/bookmark-button/bookmark-button.component';
import { removeHtmlFromString } from '../../../../../utility/app.utility';

@Component({
  selector: 'app-teaser',
  standalone: true,
  imports: [
    CarouselModule,
    PrimeTemplate,
    ButtonDirective,
    BookmarkButtonComponent,
  ],
  templateUrl: './teaser.component.html',
  styleUrl: './teaser.component.scss',
})
export class TeaserComponent {
  readonly bookmarkStore = inject(BookmarkStore);
  readonly widgetStore = inject(WidgetStore);
  link = '';
  bookmark: Bookmark | null = null;
  teaserItems: TeaserItem[] = [];
  autoplayIntervall = 0;
  protected config: CustomGridStackWidget | null = null;
  @ViewChild('carousel') carousel!: Carousel;

  @Input() id!: string;

  constructor() {
    effect(() => {
      const bookmarkState = getState(this.bookmarkStore);
      const widgetState = getState(this.widgetStore);

      if (!this.id) return;

      this.config = this.widgetStore.get(this.id);
      this.teaserItems = this.config?.widget?.teaser?.items || [];

      this.restartAutoplay();
    });
  }

  /**
   * Checks whether the autoplay feature is enabled in the configuration.
   *
   * @return {boolean} Returns true if autoplay is enabled; otherwise, false.
   */
  get hasAutoplay(): boolean {
    return !!this.config?.widget?.teaser?.autoPlay;
  }

  /**
   * Restarts the autoplay functionality of the carousel. Stops the current autoplay and, if enabled, schedules a restart with the predefined interval.
   *
   * @return {void} Does not return a value.
   */
  restartAutoplay(): void {
    if (this.carousel) {
      this.autoplayIntervall = 0;
      this.carousel.stopAutoplay();

      // Start autoplay if `hasAutoplay` is greater than 0
      if (this.hasAutoplay && !this.carousel.isPlaying()) {
        this.autoplayIntervall = 5000;
        setTimeout(() => {
          this.carousel.startAutoplay();
        }, 10);
      }
    }
  }

  protected readonly removeHtmlFromString = removeHtmlFromString;
}
